import { Profanity, ProfanityOptions } from "@2toad/profanity";

// options instance
const options = new ProfanityOptions();
options.wholeWord = true;

// profanity instance
const profanity = new Profanity(options);

export default profanity;
